import { computed, Injectable, Signal, signal } from '@angular/core'
import { HEADER_HEIGHT, MENU_ITEM_HEIGHT, MENU_PADDING } from '@ui-core/constants/app.constant'
import { MenuItem } from 'primeng/api'

@Injectable({
    providedIn: 'root',
})
export class MenuService {
    private _menu = signal<MenuItem[]>([])
    private _isSideMenuVisible = signal<boolean>(false)
    private _isCollapsed = signal<boolean>(true)
    private _menuItemsCount = signal<number>(0)

    menuSectionBottom = computed(() => {
        const itemsHeight = this._menuItemsCount() * MENU_ITEM_HEIGHT
        return HEADER_HEIGHT + itemsHeight + MENU_PADDING
    })

    public get(): Signal<MenuItem[]> {
        return this._menu
    }

    public set(value: MenuItem[]): void {
        this._menu.set(value)
    }

    public getIsSideMenuVisible(): Signal<boolean> {
        return this._isSideMenuVisible
    }

    public setIsSideMenuVisible(value: boolean): void {
        this._isSideMenuVisible.set(value)
    }

    public getIsCollapsed(): Signal<boolean> {
        return this._isCollapsed
    }

    public setIsCollapsed(value: boolean): void {
        this._isCollapsed.set(value)
    }

    public toggleCollapsed(): void {
        this._isCollapsed.set(!this._isCollapsed())
    }

    public updateCollapseForRoute(expandMenu: boolean): void {
        this._isCollapsed.set(!expandMenu)
    }

    public getMenuItemsCount(): Signal<number> {
        return this._menuItemsCount
    }

    public setMenuItemsCount(count: number): void {
        this._menuItemsCount.set(count)
    }

    public getMenuSectionBottom(): Signal<number> {
        return this.menuSectionBottom
    }
}
